/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Nivel 2: Listar vídeos/partidos de un equipo.
 */
export interface StatsAiTeamVideosRequest { 
    team_id: string;
    season_id?: number | null;
    competition_ids?: Array<number> | null;
    category_ids?: Array<number> | null;
    genders?: Array<string> | null;
    page?: number;
    page_size?: number;
}

